import { Component } from '@angular/core';

@Component({
  selector: 'app-settings',
  template: `<div class="empty-tab"><p>Settings — coming soon</p></div>`,
  styles: [`.empty-tab { padding: 40px 24px; color: #909090; font-size: 0.9rem; }`],
})
export class SettingsComponent {}
